<section class="comp-payment-info">
  <div>
    <div *ngIf="isGovAgency" class="instruction-text">Payment Terms are not applicable for Government Agencies, System defaults these values.</div>
    <p-fieldset *ngIf="paymentSettings">
      <form #dialogForm="ngForm">
        <div *ngIf="orgType !== OrgType.Org">
          <div class="p-grid">

            <div class="p-col-12 p-md-6 p-lg-6">
              <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>Preferred Delivery Method
                    <span *ngIf="!isGovAgency">*</span>
                  </label>
                </div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  <p-dropdown name="preferDeliveryType"
                              [placeholder]="PrimeNgConfig.DropdownPlaceholder" [options]="shipTypesDropDown"
                              [(ngModel)]="paymentSettings[0].preferDeliveryType" [disabled]="isGovAgency" required
                              #delivery="ngModel"></p-dropdown>
                  <div *ngIf="delivery.invalid && (delivery.dirty || delivery.touched)" class="alert alert-danger">
                    <div *ngIf="delivery.errors.required">
                      Delivery method is required
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-col-12 p-md-6 p-lg-6">
              <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>Payment Terms
                    <span *ngIf="!isGovAgency">*</span>
                  </label>
                </div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  <p-dropdown name="paymentTermsName" placeholder="Select..." [options]="paymentTermsDropdown" [(ngModel)]="paymentTerm"
                              (onChange)="onPaytermSelect($event)"
                              required #payTerm="ngModel"></p-dropdown>
                  <div *ngIf="payTerm.invalid && (payTerm.dirty || payTerm.touched)" class="alert alert-danger">
                    <div *ngIf="payTerm.errors.required">
                      Payment term is required
                    </div>
                  </div>
                  <button pButton type="button" icon="fa fa-eye" (click)="openPaymentPopUp()" [disabled]="!paymentTerm"></button>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-6 p-lg-6">
              <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>Preferred Payment Method
                    <span *ngIf="!isGovAgency">*</span>
                  </label>
                </div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  <p-dropdown name="preferPaymentType" placeholder="Select..." [options]="paymentTypesDropDown"
                              [(ngModel)]="paymentSettings[0].preferPaymentType" [disabled]="isGovAgency" required
                              #payment="ngModel"></p-dropdown>

                  <button *ngIf="paymentSettings[0].preferPaymentType=== DisbursementType.ACH && tradingPartner.id" pButton type="text" class="action-secondary"
                          icon="fa fa-eye" label="Details" (click)="displayAchCustomerPopUp($event,op1)"></button>
                  <button *ngIf="paymentSettings[0].preferPaymentType=== DisbursementType.ACH && tradingPartner.id" pButton class="action-secondary"
                          icon="fa fa-info-circle" label="FAQs"
                          (click)="showFAQDialog = true"></button>

                  <button pButton class="action-secondary"
                          icon="fa fa-info-circle" (click)="showInfoOnPaymentMethod($event,op1)"></button>


                  <div *ngIf="payment.invalid && (payment.dirty || payment.touched)" class="alert alert-danger">
                    <div *ngIf="payment.errors.required">
                      Payment method is required
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-6 p-lg-6">
              <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>Credit Line </label>
                </div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">$</span>
                    <input pInputText name="creditLine" type="text" [pattern]="RegExp12DigitInteger2DigitFraction" pKeyFilter="pnum"
                           [maxlength]="Validation.CreditLimitMaxLength" [(ngModel)]="paymentSettings[0].creditLimit" [readOnly]="isGovAgency"
                           #creditLine="ngModel">
                  </div>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-6 p-lg-6">
              <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>Special Discount</label>
                </div>
                <div class="p-col-12 p-md-8 p-lg-8">
                  <span class="p-inputgroup">
                    <input pInputText name="specialDiscount" type="text" pKeyFilter="num"
                           maxlength=Validation.DiscountMaxLength [(ngModel)]="paymentSettings[0].specialDiscount" [readOnly]="isGovAgency">
                    <span class="p-inputgroup-addon">%</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="p-col-12 p-md-6 p-lg-6">
              <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                  <label>Account # </label>
                </div>
                <div *ngIf="paymentSettings&&paymentSettings.length>=1&&!paymentSettings[0].displayAccountNumber" class="p-col-12 p-lg-4">
                  <label> _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ </label>
                </div>
                <div *ngIf="paymentSettings&&paymentSettings.length>=1&&paymentSettings[0].displayAccountNumber"
                     class="p-col-12 p-lg-8">{{paymentSettings[0].displayAccountNumber}}
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="(orgType === OrgType.Vendor || orgType === OrgType.Customer) && ( tradingPartner?.currentStatusName ===
          ApprovalStatusType.Completed || CurrentTxnStatus.isEditable(tradingPartner?.currentStatusName))" class="p-col-12 p-md-12 p-lg-12">
            <button pButton type="button" class="button-action pull-right" icon="fa fa-check" label="Save" (click)="onClickSavePaymentSettings()"
                    [disabled]="!dialogForm.form.valid"></button>
          </div>
        </div>
      </form>
    </p-fieldset>
    <div class="p-col-12">&nbsp;</div>

    <app-data-table [columns]="achDetailsColumn" [value]="achDetails" [bodyTemplate]="bodyTemplate" [rightCaptionTemplate]="captionTemplate">

      <ng-template #captionTemplate>
        <div class="p-col-12" style="text-align:right;">
          <button pButton type="button" class="action-secondary" icon="fa fa-plus" label="Account" pTooltip="Add Account"
                  tooltipPosition="top" (click)="addAchDetailDisplay()" [disabled]="!displayAddAchDetail || isGovAgency || (paymentSettings &&
                    paymentSettings[0] && paymentSettings[0].preferPaymentType !== DisbursementType.ACH)">
          </button>
          <button *ngIf="!displayAddAchDetail" pButton class="icon-action" icon="fa fa-info-circle"
                  pTooltip="You can have a maximum of Six funding sources"
                  tooltipPosition="top"></button>
        </div>
      </ng-template>


      <ng-template #bodyTemplate let-row="row" let-index="rowIndex" let-columns="columns">
        <tr *ngIf="row?.active">
          <td *ngFor="let col of columns" [ngSwitch]="col.field">
            <span class="p-column-title">{{col.header}}</span>
            <span class="p-cell">
              <div *ngSwitchCase="'current'">
                <p-checkbox binary="true" [ngModel]="row.current" [disabled]="true"></p-checkbox>
              </div>

              <div *ngSwitchCase="'accountType'">{{row[col.field] | titleCase}}</div>

              <div *ngSwitchCase="'action'">
                <button pButton type="button" class="icon-action" icon="fa fa-pencil" pTooltip="Edit Account" tooltipPosition="top" (click)="editAchDetailDisplay(row)">
                </button>

                <button *ngIf="row?.achFundingSourceDetails" pButton type="button" class="icon-action" icon="fa fa-dollar" pTooltip="Show Ach Funding Source Detail"
                        tooltipPosition="top"
                        (click)="showAchFundingSourceDetail(row)">
                </button>
                <button pButton type="button"
                        class="icon-negative"
                        icon="fa fa-trash" pTooltip="Account Detail" tooltipPosition="top" (click)="onClickDeleteAch(row)"
                        [disabled]="paymentSettings && paymentSettings[0] && paymentSettings[0].preferPaymentType === DisbursementType.ACH">
                </button>

                <button *ngIf="row?.achFundingSourceDetails?.status === FundingSourceStatus.Removed" pButton type="button" class="icon-negative" icon="fa fa-exclamation-triangle"
                        pTooltip="Error with funding source" tooltipPosition="top"
                        (click)="showAchFundingSourceDetail(row)">
                </button>

                <button *ngIf="row?.achFundingSourceDetails?.status === FundingSourceStatus.UnVerified || row?.achFundingSourceDetails?.status ===
                  FundingSourceStatus.MicroDepositInitiated" pButton type="button" class="icon-negative" icon="fa fa-exclamation-triangle"
                        pTooltip="Action Required" tooltipPosition="top"
                        (click)="showAchFundingSourceDetail(row)">
                </button>
              </div>
              <div *ngSwitchDefault>{{row[col.field]}}</div>
            </span>
          </td>
        </tr>
      </ng-template>

    </app-data-table>

  </div>


  <p-dialog *ngIf="paymentTerm" [(visible)]="openPaymentTermsDialog" header="Manage Payment Terms" [modal]="true" [responsive]="true"
            [style]="PrimeNgConfig.DialogStyle40">

    <div *ngIf="paymentTerm?.standardTermName?.length > 0">
      <h4>Standard Terms</h4>
      <p> Select your terms to manage name and rules.</p>

      <label>Name</label>
      <input pInputText name="standardTermName" type="text" size="20" maxlength=Validation.TermNameMaxLength style="margin:0px 10px 20px 10px"
             [(ngModel)]="paymentTerm.standardTermName" readOnly>
      <h4>Rules:</h4> Net due in
      <input pInputText name="daysDueAfterBill" type="text" pattern="^[0-9]{1,3}$" size="5"
             [maxlength]=Validation.DaysMaxLength style="width:100px!important;margin:0px 10px 10px 10px" [(ngModel)]="paymentTerm.daysDueAfterBill" readOnly> days after invoice or bill.
      <br> Discount is
      <input pInputText name="discountIfPaidEarlyStd" type="text" pattern="^[0-9]{1,2}$"
             size="5" maxlength=Validation.DaysMaxLength style="width:100px!important;margin:0px 10px 10px 10px" [(ngModel)]="paymentTerm.discountIfPaidEarly" readOnly> % if paid
      within
      <input pInputText name="daysToPayForDiscount" type="text" pattern="^[0-9]{1,3}$" size="5"
             [maxlength]=Validation.DaysMaxLength
             style="width:100px!important;margin:0px 10px 10px 10px" [(ngModel)]="paymentTerm.daysToPayForDiscount" readOnly>days of the invoice. Interest amount if paid past due date:
      <input pInputText name="pastDueInterestRateStd" type="text" pattern="^[0-9]{1,2}$" size="5"
             [maxlength]=Validation.DaysMaxLength style="width:100px!important;margin:0px 10px 10px 10px" [(ngModel)]="paymentTerm.pastDueInterestRate" readOnly> %
    </div>

    <div *ngIf="paymentTerm?.monthlyTermName?.length > 0">
      <h4>Monthly Terms</h4>
      <p> Select your terms to manage name and rules.</p>
      <p>Name
        <input pInputText name="monthlyTermName" type="text" size="20" [maxlength]=Validation.TermNameMaxLength style="margin:0px 10px 10px 10px"
               [(ngModel)]="paymentTerm.monthlyTermName" readOnly>
        <br> Rules:

        <br> Net due before the
        <input pInputText name="dayofMonthBillDue" type="text" pattern="^[0-9]{1,2}$" size="5" [maxlength]=Validation.DaysMaxLength
               style="margin:0px 10px 10px 10px" [(ngModel)]="paymentTerm.dayofMonthBillDue" readOnly>th day of the month.
        <br>Due next month if within

        <input pInputText name="dayofMonthForNextMonth" type="text" pattern="^[0-9]{1,2}$"
               size="5"
               [maxlength]=Validation.DaysMaxLength style="margin:0px 10px 10px 10px" [(ngModel)]="paymentTerm.dayofMonthForNextMonth" readOnly> days(s) of due date. Discount is
        <input pInputText name="discountIfPaidEarlyCustom" type="text" pattern="^[0-9]{1,2}$"
               size="5"
               [maxlength]=Validation.DaysMaxLength style="margin:0px 10px 10px 10px" [(ngModel)]="paymentTerm.discountIfPaidEarly" readOnly>% if paid before
        <input pInputText name="dayofMonthForDiscount" type="text" pattern="^[0-9]{1,2}$" size="5"
               [maxlength]=Validation.DaysMaxLength style="margin:0px 10px 10px 10px" [(ngModel)]="paymentTerm.dayofMonthForDiscount" readOnly>day of the month. Interest
        amount if paid past due date:

        <input pInputText name="pastDueInterestRateCustom" type="text" pattern="^[0-9]{1,2}$"
               size="5"
               [maxlength]=Validation.DaysMaxLength style="margin:0px 10px 10px 10px" [(ngModel)]="paymentTerm.pastDueInterestRate" readOnly>% </p>
    </div>


    <div class="btn">
      <button pButton type="button" icon="fa fa-close" label="Cancel" (click)="cancelPaymentTerms()"></button>
    </div>
  </p-dialog>

  <div style="margin-top:10px;">
    <div class="p-col-12 p-md-4 p-lg-4">
      <button *ngIf="orgType !== OrgType.Org"
              pButton type="button" class="action-secondary" icon="fa fa-arrow-circle-left" label="Return To Summary"
              [routerLink]="[RouteLink.TradingPartnerSummary,orgType]">
      </button>
      <button *ngIf="orgType === OrgType.Org"
              pButton type="button" class="action-secondary" icon="fa fa-arrow-circle-left" label="Return To Summary" [routerLink]="RouteLink.SolMgrOrgSummary">
      </button>
    </div>
  </div>
  <div style="clear:both"></div>

</section>


<div *ngIf="showAddEditDialog">
  <p-dialog [(visible)]="showAddEditDialog" header="Ach Detail" [modal]="true" [responsive]="true" [resizable]="false"
            [style]="PrimeNgConfig.DialogStyle40" (onHide)="cancelAchDetail($event)">
    <form #dialogForm="ngForm">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Nickname*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText name="nickName" type="text" [maxlength]="Validation.BankNickNameMaxLength" [(ngModel)]="selectedAchDetail.nickName"
                 required>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Bank Name*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText name="bankName" type="text" [maxlength]="Validation.BankNameMaxLength" [(ngModel)]="selectedAchDetail.bankName"
                 required>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Account Type*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown name="accountType" placeholder="Select..." [options]="achAccountTypesDropdown" [(ngModel)]="selectedAchDetail.accountType" required></p-dropdown>
        </div>
      </div>
      <div *ngIf="orgType === OrgType.Org" class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Default Payment Type*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown name="achDefaultPaymentType" placeholder="Select..." [options]="achDefaultPaymentTypeDropdown" [(ngModel)]="selectedAchDetail.achDefaultPaymentType"
                      required></p-dropdown>
        </div>

      </div>
      <div *ngIf="orgType === OrgType.Vendor" class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Primary Pay*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-selectButton name="currentFundingSource" [options]="viewOptions" [(ngModel)]="selectedAchDetail.current"></p-selectButton>

        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Account Name*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText name="accountName" type="text" [maxlength]="Validation.BankAccountNameMaxLength"
                 [(ngModel)]="selectedAchDetail.accountName" required>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Routing Number*</label>
        </div>
        <div class="p-col-12  p-lg-8">
          <input pInputText name="routingNumber" type="text" pattern="^[0-9]{1,9}$"
                 pKeyFilter="int"
                 [maxlength]="Validation.BankRoutingNumberMaxLength" [(ngModel)]="selectedAchDetail.routingNumber" (blur)="validateRoutingNumber(selectedAchDetail.routingNumber)" required>
          <div *ngIf="selectedAchDetail.routingNumber && !this.validRoutingNumber" class="alert alert-danger">
            Enter a valid routing number
          </div>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Account Number*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText name="accountNumberInFieldset" type="text" pattern="^[0-9]{1,17}$" pKeyFilter="int"
                 [minlength]="Validation.BankAccountNumberMinLength" [maxlength]="Validation.BankAccountNumberMaxLength"
                 [(ngModel)]="selectedAchDetail.accountNumber" required>
        </div>
      </div>

      <div *ngIf="orgType === OrgType.Vendor">
        <div *ngIf="(!selectedAchDetail?.id && selectedAchDetail?.current)" class="p-col-12 p-md-12 p-lg-12">
          <p class="instruction-text">{{VendorPaymentMessages.NewAchUseForPrimaryPay}}</p>
        </div>

        <div *ngIf="(selectedAchDetail?.id && selectedAchDetail?.current)" class="p-col-12 p-md-12 p-lg-12">
          <p class="instruction-text">{{VendorPaymentMessages.UpdateAchForPrimaryPay}}</p>
        </div>
      </div>

      <!--Check options for Org Ach-->
      <div *ngIf="orgType === OrgType.Org" class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Enable Check Payments?*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-selectButton name="enableCheck" [options]="viewOptions" [(ngModel)]="selectedAchDetail.enableCheckPayment" ></p-selectButton>
        </div>

        <div *ngIf="selectedAchDetail.enableCheckPayment" class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Payer Address*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-dropdown name="achPayerAddress" [placeholder]="Validation.DropdownPlaceholder" [options]="payerAddressDropdown"
                        filter="true" [(ngModel)]="selectedAchDetail.payerAddressId" required></p-dropdown>
          </div>

          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Check Delivery*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-radioButton name="checkPaymentType" [value]="CheckPaymentType.PrintOnly" label="Print for Download" [(ngModel)]="selectedAchDetail.checkPaymentType" required></p-radioButton>
            <p-radioButton name="checkPaymentType" [value]="CheckPaymentType.PrintAndDeliver" label="Print & Deliver" [(ngModel)]="selectedAchDetail.checkPaymentType" required></p-radioButton>

          </div>

          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Signature to Use*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-radioButton name="sigToUse" [value]="true" label="Text" [(ngModel)]="selectedAchDetail.useSignatureText" required></p-radioButton>
            <p-radioButton name="sigToUse" [value]="false" label="Image" [(ngModel)]="selectedAchDetail.useSignatureText" required></p-radioButton>

          </div>


          <div *ngIf="selectedAchDetail.useSignatureText" class="p-col-12 p-md-4 p-lg-4">
            <label>Signature Text*</label>
          </div>
          <div *ngIf="selectedAchDetail.useSignatureText" class="p-col-12 p-md-8 p-lg-8">
            <input pInputText name="sigText" type="text"
                   [maxLength]="Validation.SignatureLength" [(ngModel)]="selectedAchDetail.signatureText" required>
          </div>


          <div *ngIf="!selectedAchDetail.useSignatureText" class="p-col-12 p-md-4 p-lg-4">
            <label>Signature Image*</label>
          </div>
          <div *ngIf="!selectedAchDetail.useSignatureText" class="p-col-12 p-md-8 p-lg-8">
            <button *ngIf="selectedAchDetail?.signatureImage?.id" pButton type="button" class="action-secondary" icon="fa fa-download" label="Download"
                    (click)="onClickDownload(selectedAchDetail)"></button>
            <app-file-load [docType]="DocumentType.Check" [maxFileSize]="Validation.SignatureImageSize" [fileType]="Validation.SignatureImageType"
                           (loadHandler)="handleSignatureImage($event)"></app-file-load>

          </div>

          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Sample Check</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <button pButton type="button" class="button-action" icon="fa fa-check" label="Generate" (click)="generateSampleCheck()"></button>
          </div>

        </div>
      </div>


    </form>

    <p-footer>
      <div class="details" style="text-align:right;padding-top:10px;">
        <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel" (click)="cancelAchDetail()">
        </button>
        <span *ngIf="saveOrUpdate">
          <button pButton type="button" class="button-action"
                  icon="fa fa-check"
                  label="Save" (click)="addAchDetail()" [disabled]="!dialogForm.form.valid || ( selectedAchDetail?.enableCheckPayment && !selectedAchDetail?.useSignatureText &&
          !selectedAchDetail.signatureImage) || (!validRoutingNumber)">
          </button>
        </span>
        <span *ngIf="!saveOrUpdate">
          <button pButton type="button" class="button-action" icon="fa fa-check" label="Update" (click)="onClickEditAchDetail()"
                  [disabled]="!dialogForm.form.valid || (!validRoutingNumber)">
          </button>
        </span>

      </div>

    </p-footer>

  </p-dialog>

</div>


<div *ngIf="showAddEditFundingSourceDetailDialog">
  <p-dialog [(visible)]="showAddEditFundingSourceDetailDialog" header="Funding Source Detail" [modal]="true" [responsive]="true" [resizable]="false"
            [style]="PrimeNgConfig.DialogStyle40">

    <form #dialogForm="ngForm">

      <div class="p-grid">

        <div *ngIf="selectedAchDetail?.achFundingSourceDetails?.status === FundingSourceStatus.Removed" class="p-col-12 p-md-12 alert alert-danger ">
          Funding Source has been removed by our partner dwolla, This usually occurs when the entered funding source details are incorrect (or) Does not have
          proper authorization (or) A frozen bank account. Please Correct the account details/create a new funding source.
        </div>

        <div *ngIf="selectedAchDetail?.achFundingSourceDetails?.status === FundingSourceStatus.UnVerified" class="p-col-12 p-md-12 alert alert-danger ">
          {{DwollaMessages.MicroDepositInitiationMessage}}
        </div>

        <div *ngIf="selectedAchDetail?.achFundingSourceDetails?.status === FundingSourceStatus.MicroDepositInitiated" class="p-col-12 p-md-12 alert alert-danger ">
          {{DwollaMessages.MicroDepositVerificationMessage}}
        </div>
        <div class="p-grid" style="width:100%;">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>ACH Funding Source ID</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            {{selectedAchDetail?.achFundingSourceDetails?.fundingSourceId}}
          </div>
        </div>
        <div class="p-grid" style="width:100%;">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>ACH Funding Source Status*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            {{selectedAchDetail?.achFundingSourceDetails?.status}}
          </div>
        </div>
        <div *ngIf="selectedAchDetail?.achFundingSourceDetails?.status === FundingSourceStatus.MicroDepositInitiated" class="p-grid" style="width:100%;">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Amount1*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <span class="p-inputgroup">
              <input name="amount1" type="number" [(ngModel)]="microDepositVerification.amount1.value"/>
              <span class=" p-inputgroup-addon">$</span>
            </span>
          </div>
          <div class="p-grid" style="width:100%;">
            <div class="p-col-12 p-md-4 p-lg-4">
              <label>Amount2*</label>
            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
              <span class="p-inputgroup">
                <input name="amount2" type="number" [(ngModel)]="microDepositVerification.amount2.value"/>
                <span class=" p-inputgroup-addon">$</span>
              </span>
            </div>

          </div>
        </div>
      </div>

    </form>

    <p-footer>
      <div class="details" style="text-align:right;padding-top:10px;"></div>

      <div *ngIf="selectedAchDetail?.achFundingSourceDetails?.status === FundingSourceStatus.UnVerified">
        <button pButton type="button" class="button-action" icon="fa fa-check" label="Initiate Micro Deposit Verification" (click)="initiateMicroDepositVerification(selectedAchDetail)">
        </button>

      </div>

      <div *ngIf="selectedAchDetail?.achFundingSourceDetails?.status === FundingSourceStatus.MicroDepositInitiated">
        <button pButton type="button" class="button-action" icon="fa fa-check" label="Verify Micro Deposit " (click)="verifyMicroDeposit(selectedAchDetail, microDepositVerification)">
        </button>
      </div>

      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel" (click)="onClickCancelFundingSourceStatus()"></button>
    </p-footer>

  </p-dialog>

</div>

<p-confirmDialog key="deleteAch"></p-confirmDialog>
<p-confirmDialog key="updateAch"></p-confirmDialog>

<p-overlayPanel [style]="{'width':'500px'}" #op1 [showCloseIcon]="true" [dismissable]="true" [appendTo]="op1">

  <div class="p-grid">

    <div class="p-col-12 p-md-4 p-lg-4">
      <label> ACH Customer Id </label>
    </div>

    <div class="p-col-12 p-md-9 p-lg-9">
      {{tradingPartner?.achCustomerDetails?.customerId}}

    </div>

    <div class="p-col-12 p-md-4 p-lg-4">
      <label> ACH Customer Status</label>
    </div>

    <div class="p-col-12 p-md-9 p-lg-9">
      {{tradingPartner?.achCustomerDetails?.status}}

    </div>

  </div>

  <p *ngIf="orgType !== OrgType.Customer"><strong>ACH</strong> - Electronic payment provided by OneLynk through Dwolla.</p>
  <p><strong>Cash</strong> - Cash payment. </p>
  <p><strong>Check</strong> - Manual or check payment service provided by OneLynk through Checkeeper. </p>
  <p><strong>Other Electronic</strong> - Other electronic payment method used by customer. Not provided by One Lynk.</p>

</p-overlayPanel>


<p-dialog [(visible)]="showFAQDialog" header="Automated Clearing House (ACH) FAQs" [modal]="true" [responsive]="true" [resizable]="false"
          [style]="PrimeNgConfig.DialogStyle65" [contentStyle]="{'overflow-y':'scroll'}">

  <div class="p-grid">
    <app-ach-faq></app-ach-faq>
  </div>

  <p-footer>
    <div style="margin:15px;text-align:right;">
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Close" (click)="showFAQDialog = false"></button>
    </div>
  </p-footer>

</p-dialog>

